import Modal from 'react-responsive-modal';
import linkifyHtml from 'linkify-html';
import React, { Fragment, useEffect } from 'react';

const renderResults = (name, results, icon, style, showCanned = true) => {
  const cannedMsgStyle =  { listStyleType: "none", listStylePosition: "none", margin:0, padding:0 }
  if ( results.length <= 0 ) return '';
  return <Fragment>
    <h2><i className={`fas ${icon}`} style={style}></i>&nbsp;{name}</h2>
    <ul>
      {results.map(({label, canned_messages}, index) => {
        return <li key={index}><span className="linkify">{label}</span>
          { showCanned && canned_messages && canned_messages.length > 0 && <div><strong> Feedback: </strong>
           <ul style={cannedMsgStyle} > 
            { canned_messages.map((m,index) => <li key={index} style={cannedMsgStyle} dangerouslySetInnerHTML={{ __html: linkifyHtml(m) }} />) }
           </ul></div> }
        </li>
      })}
    </ul>
  </Fragment>
}

const renderStoryPoster = (elements) => {
  if (elements && elements['amp-story-poster-portrait-src']) {
    return <ul>
      <li>Poster Image:
        <div style={{textAlign: "center"}}>
          <img width="200px" src={elements['amp-story-poster-portrait-src']} />
        </div>
      </li>
    </ul>
  } else { return '' }
}

const QAResultModal = ({open, onCloseModal, result}) => {
  
  useEffect(() => {
    const elements = document.querySelectorAll("span.linkify");
    elements.forEach(function(el) {
      el.innerHTML = linkifyHtml(el.innerHTML)
    });
  });

  return (
    <div>
      <Modal open={open} onClose={onCloseModal} center>
        { renderResults("Errors", result.failures, 'fa-times-circle', {color: "red"}) }
        { renderResults("Warnings", result.warnings, 'fa-exclamation-triangle', {color: "#ffc107"}) }
        { renderResults("Info", result.info, 'fa-info-circle', {color: "lightgray"}, false) }
        { renderStoryPoster(result.elements) }
      </Modal>
    </div>
  );
}

export default QAResultModal;